import { Flex } from '@skooldio/skooldio-ui-components-core';

export default Flex;
